module.exports = __webpack_public_path__ + "img/tf_bg.d82a35dc.webp";